module.exports = __webpack_public_path__ + "static/media/tick-active.d39f6d8e.svg";